import React, { useState, useEffect } from "react";
import { DimensionTypes, SupportedTypes } from "./LogicalOperatorsOptions";

/**
 * List all primitive types supported by each logical operator
 */
const FilterSelectListTypes = (props) => {
  const myRef = React.useRef(null);
  // defines which primitive type is selected. String should be the default one
  const [selectedType, setSelectedType] = useState(
    // get the default value from props or the default one from component
    props.value || SupportedTypes.String
  );

  // defines when the list should be shown or not
  const [showList, setShowList] = useState(false);

  // Close the list when the component loses focus
  const handleOutsideClick = (event) => {
    // close the dropdown when the use clicks outside the context
    if (
      !event.target.classList.contains("filter-select-list-types") &&
      !event.target.classList.contains("dropdown-menu-item")
    )
      setShowList(false);
  };

  useEffect(() => {
    window.addEventListener("click", handleOutsideClick);
    return () => {
      window.removeEventListener("click", handleOutsideClick);
    };
  });

  const onOptionClick = (optionType) => {
    setSelectedType(optionType);
    setShowList(false);
    props.onOptionClick && props.onOptionClick(optionType);
  };

  /**
   * Builds the new supported type getting all the keys from all SupportedType
   * based on the list of keys of the dimensionType
   * @param {*} dimensionType
   * @returns
   */
  const buildNewSupportedTypes = (dimensionType) => {
    const newSupportedType = {};
    // get all available types for the current dimension based on its type
    DimensionTypes[props.type].forEach((availableType) => {
      // inject the prop and its value into the newSupportedType
      newSupportedType[availableType] = SupportedTypes[availableType];
    });
    return newSupportedType;
  };

  // get all options available as filter according the dimension type.
  let optionsByPrimitiveType = !props.type // if no primitive type (dimension) is set
    ? SupportedTypes // get all default supported types
    : buildNewSupportedTypes(props.type); // in other case, get all options according the dimension type

  // if no option was found based on the dimension type, get the default ones
  if (!optionsByPrimitiveType) {
    optionsByPrimitiveType = SupportedTypes;
  }
  return (
    <div className="option-dropdown-block pl-2 pb-1" ref={myRef}>
      <span
        className="option-dropdown-header filter-select-list-types"
        onClick={() => setShowList(!showList)}
      >
        {selectedType}
      </span>
      {showList && (
        <ul className="option-dropdown">
          {Object.keys(optionsByPrimitiveType).map((optionType) => (
            <li
              key={optionType}
              onClick={() => onOptionClick(optionType)}
              className="dropdown-menu-item"
            >
              {optionsByPrimitiveType[optionType]}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default FilterSelectListTypes;
